import optenrLogo from "@/assets/logos/optenr-logo.png";
import moddeLogo from "@/assets/logos/modde-logo.png";
import smLogo from "@/assets/logos/sm-logo.png";
import secretLogo from "@/assets/logos/secret-logo.png";
import sezonLogo from "@/assets/logos/sezon-logo.png";
import marceloLogo from "@/assets/logos/marcelo-logo.png";
import venomLogo from "@/assets/logos/venom-logo.png";
import amstrgLogo from "@/assets/logos/amstrg-logo.png";
import hustlerLogo from "@/assets/logos/hustler-logo.png";

const logos = [
  { src: moddeLogo, alt: "Moddé" },
  { src: optenrLogo, alt: "Optenr" },
  { src: secretLogo, alt: "Secret Community" },
  { src: sezonLogo, alt: "Сезон Славы", isWhite: true },
  { src: smLogo, alt: "SM" },
  { src: marceloLogo, alt: "Marcelo Miracles", scale: 1.25 },
  { src: venomLogo, alt: "Venom Kiss" },
  { src: amstrgLogo, alt: "Amstrg", scale: 1.2 },
  { src: hustlerLogo, alt: "Hustler Club", scale: 1.2 },
];

export const BrandLogos = () => {
  return (
    <div className="w-full overflow-x-auto scrollbar-hide">
      <div className="flex items-center justify-between gap-3 sm:gap-4 md:gap-10 lg:gap-14 px-4 md:px-12 lg:px-20 w-full">
        {logos.map((logo, index) => (
          <div 
            key={index}
            className="flex items-center justify-center flex-shrink-0"
          >
            <img
              src={logo.src}
              alt={logo.alt}
              width={85}
              height={85}
              loading="lazy"
              decoding="async"
              className="h-[24px] sm:h-[32px] md:h-[68px] lg:h-[85px] w-auto object-contain"
              style={{
                filter: logo.isWhite 
                  ? 'brightness(200) contrast(1) grayscale(100%) drop-shadow(0 0 12px rgba(255,255,255,0.2))'
                  : 'brightness(100) contrast(0.9) grayscale(100%) drop-shadow(0 0 12px rgba(255,255,255,0.2))',
                opacity: 0.9,
                transform: logo.scale ? `scale(${logo.scale})` : undefined,
              }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};
